module.exports = "/_next/static/images/washington-dc-fast-channel-description-image-black-letters-9afd3e9825b19e341c3b24cdff4506af.svg";